var environ = (process.env.NODE_ENV) ? process.env.NODE_ENV : 'local';

switch(environ) {
case 'production':
  module.exports = require('./production')
  break
case 'staging':
  module.exports = require('./staging')
  break
case 'ssr':
  module.exports = require('./ssr')
  break
default:
  module.exports = require('./local')
  break
}



// WEBPACK FOOTER //
// ./src/settings/index.js